import AlternativeLabelsEditorPage from "@Alternatives/AlternativesLists/Pages/AlternativeLabelsEditorPage.vue";
import AlternativesKanbanPage from "@Alternatives/AlternativesLists/Pages/AlternativesKanbanPage.vue";
import ManageKanbanStatusesPage from "@Alternatives/AlternativesLists/Pages/ManageKanbanStatusesPage.vue";
import RelationshipsPage from "@Alternatives/AlternativesLists/Pages/RelationshipsPage.vue";

export const routes = [
    {
        path: "/alternatives/kanban/:workspaceId/:projectId/:viewDefId?",
        component: AlternativesKanbanPage
    },
    {
        path: "/alternatives-labels/:workspaceId/:projectId",
        component: AlternativeLabelsEditorPage
    },
    {
        path: "/kanban-statuses/:workspaceId/:projectId",
        component: ManageKanbanStatusesPage
    },
    {
        path: "/pp/dependencies/:workspaceId/:projectId",
        component: RelationshipsPage
    },
]
